import React from 'react'
import blindImg from "../../../../../../assets/windTree/products/dreamBlinds.webp"
import Heading from '../../../utils/Heading'
import { useNavigate } from 'react-router-dom'
import { Phone } from 'lucide-react';

export default function ServicePage() {
    const navigate = useNavigate();
  return (
    <div className='flex flex-col lg:flex-row items-start gap-7 p-5'>
        <div className="w-full md:min-w-[650px] min-h-auto ">
            <img className="object-cover w-full h-full" src={blindImg} />
        </div>

        <div>
            <Heading className="!text-left" text={"Window Blinds "} subText={"Installation Service"} /> <br/>
            <div className="text-[#0d5f07] font-bold text-2xl">₹ 200.00 - 1,000.00 <span className="text-black text-sm">/ pc</span></div>
            <div className="text-black font-bold text-xl pb-2">10 pc<span className="text-gray-500 text-md font-normal"> (MOQ)</span></div>
            <p className="text-[20px] leading-1">Our Window Blinds Installation Service offers seamless, professional installation for your home or office. Our skilled technicians ensure precise measurements and secure fittings, guaranteeing a perfect fit for your windows. We handle a variety of blind types, including Venetian, roller, vertical, and more, accommodating any style or size requirement. With our meticulous attention to detail and commitment to customer satisfaction, you can trust us to enhance your space with functional and stylish window treatments. Experience hassle-free installation with our reliable service.</p>
            <br/>
             <button
              className="group inline-flex items-center gap-3 bg-[#661e33] text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded-full font-semibold transition-all duration-300 hover:bg-[#582635] hover:shadow-lg text-sm sm:text-base border border-[#D1BC9F]/40"
              onClick={() => navigate("/contact-us")}
            >
                <Phone className="w-5 h-5" />
              Contact Us
            </button>
        </div>
    </div>
  )
}
